import React, { Component } from "react";
//import { Link } from "react-router-dom";
import { Link, Grid, Card, CardActions, CardMedia, CardContent, Typography } from '@mui/material';
import { FcTemplate, FcTreeStructure, FcCableRelease, FcServices, FcProcess, FcSportsMode, FcTodoList, FcWorkflow, FcTimeline, FcCheckmark, FcDatabase, FcNightLandscape, FcMultipleInputs, FcFaq, FcGallery, FcNeutralDecision, FcNumericalSorting12 } from "react-icons/fc";

const HomePage = () => {

    return (
    	<>
    	
    			<Grid container spacing={2}
					justifyContent="center" // ← Horizontal centering
  					sx={{
    					width: '100%', // Ensure container takes full width
    					margin: '0 auto' // Optional: Center the grid itself if needed
  					}}>
  					<Grid item>
					<Card variant="outlined" 
						sx={{ width: 350, height: 200 }}
						elevation={10}
					>
						
						<center>
							<div>
								<FcCableRelease size={76} className="icon icon--plan"/>
                    		</div>


							<Typography variant="subtitle3" gutterBottom>
    							<Link href="/neo/connectors">Connectors</Link>
  							</Typography>
							<Typography variant="body2" sx={{ color: 'text.secondary' }}>
								Create smart agents to data sources for automation and driving insights.
  							</Typography>
						</center>
					</Card>	
					</Grid>

  					<Grid item>
					<Card variant="outlined" 
						sx={{ width: 350, height: 200 }}
						elevation={10}
					>
						
						<center>
							<div>
								<FcServices size={76} className="icon icon--plan"/>
                    		</div>
							<Typography variant="subtitle3" gutterBottom>
    							<Link href="/neo/services">Services</Link>
  							</Typography>
							<Typography variant="body2" sx={{ color: 'text.secondary' }}>
								Create smart agents to data sources for automation and driving insights.
  							</Typography>
						</center>
					</Card>	
					</Grid>

  					<Grid item>
					<Card variant="outlined" 
						sx={{ width: 350, height: 200 }}
						elevation={10}
					>
						
						<center>
							<div>
								<FcProcess size={76} className="icon icon--plan"/>
                    		</div>
							<Typography variant="subtitle3" gutterBottom>
    							<Link href="/neo/transformers">Transformers</Link>
  							</Typography>
							<Typography variant="body2" sx={{ color: 'text.secondary' }}>
								Create smart agents to data sources for automation and driving insights.
  							</Typography>
						</center>
					</Card>	
					</Grid>

				</Grid>
    	

      </>
    );
//  }
}

//                             <p>
//                                 <a href="/neo/manage-transformer/" className="ContentTitle">
//                                     Manage Transformers
//           </a>
//                             </p>
//         <p>
//           <a href="/neo/manage-connector" className="ContentTitle">
//             Manage Connectors
//           </a>
//         </p>
//                             <!--
//                             <p>
//                                 <a href="/neo/manage-service/" className="ContentTitle">
//                                     Manage Services
//           </a>
//                             </p>
//                             -->

export default HomePage;